import { Pipe, PipeTransform, inject } from '@angular/core';
import { CdnService } from '../services/cdn.service';

@Pipe({
    name: 'cdn',
    standalone: false
})
export class CdnPipe implements PipeTransform {
  private cdn = inject(CdnService);


  transform(srcUrl: string): string {
    return this.cdn.getCdnUrl(srcUrl);
  }
}
